import { createFileRoute } from "@tanstack/react-router";
import { DiagnosticsPage } from "../features/diagnostics/DiagnosticsPage";

export const Route = createFileRoute("/w/$ws/diagnostics")({
  component: DiagnosticsPage,
});
